<ng-container
  *ngFor="
    let pcg of project.projectContacts | groupProjectContacts;
    let first = first;
    let last = last
  "
>
  <div *ngIf="!client || !(first && last)">
    <div
      class="font-weight-bold click-link d-flex"
      [ngClass]="!first ? 'upper-space' : ''"
      [ngStyle]="!client ? clickLinkStyle : {}"
      [routerLink]="client ? [] : ['/bedrijven', pcg.company.id]"
    >
      <div
        [ngClass]="
          pcg.company.immoscoop || pcg.company.spotto || atLeastOneInpressLogo
            ? 'company-name-logo-margin'
            : ''
        "
      >
        {{ pcg.company.regularName }}
      </div>
      <div
        class="smaller-left-space"
        *ngIf="
          pcg.company.immoscoop || pcg.company.spotto || atLeastOneInpressLogo
        "
      >
        <img
          *ngIf="pcg.company.immoscoop"
          src="/assets/immoscoop_banner.png"
          class="immoscoop-logo"
        />
        <img
          *ngIf="pcg.company.spotto"
          src="/assets/spotto_banner.png"
          class="spotto-logo"
        />
        <img
          *ngIf="atLeastOneInpressLogo"
          src="/assets/logo.png"
          class="inpress-logo"
        />
      </div>
    </div>
    <div *ngFor="let groupContact of pcg.contacts" class="d-flex">
      <div
        [ngClass]="client ? '' : 'click-link'"
        [routerLink]="client ? [] : ['/contacten', groupContact.id]"
      >
        <span *ngIf="groupContact.firstName"
          >{{ groupContact.firstName }}
        </span>
        <span *ngIf="groupContact.lastName">{{ groupContact.lastName }}</span>
      </div>
      <div *ngFor="let phone of groupContact.telephones">
        <span>&nbsp;/&nbsp;</span>
        <a class="click-link" href="tel:{{ phone.number }}">
          {{ phone.number | asFormatPhoneNumber }}
        </a>
      </div>
      <div *ngFor="let email of groupContact.emails">
        <span>&nbsp;/&nbsp;</span>
        <a class="click-link" href="{{ mail(email.email, groupContact) }}">
          {{ email.email }}
        </a>
      </div>
    </div>
  </div>
</ng-container>
<div class="upper-space">
  <div
    *ngIf="
      getBaseProject() != null && getBaseProject().projectPlacement?.address
    "
  >
    <a
      *ngIf="
        getBaseProject().projectPlacement.address.line1 ||
        getBaseProject().projectPlacement.address.postalCode ||
        getBaseProject().projectPlacement.address.city
      "
      class="clickable-link secondary-color"
      href="https://www.google.com/maps/search/{{
        getBaseProject().projectPlacement.address.line1
          | googleMapsAddressRequest
            : getBaseProject().projectPlacement.address.city
            : getBaseProject().projectPlacement.address.postalCode
            : getBaseProject().projectPlacement.address.country
      }}"
    >
      {{ getBaseProject().projectPlacement.address.line1 }},
      {{ getBaseProject().projectPlacement.address.postalCode }}
      {{ getBaseProject().projectPlacement.address.city }}
    </a>
    <span
      class="address-text"
      *ngIf="
        !getBaseProject().projectPlacement.address.line1 &&
        !getBaseProject().projectPlacement.address.postalCode &&
        !getBaseProject().projectPlacement.address.city
      "
    >
      Er zijn geen adres gegevens ingevuld
    </span>
  </div>
  <ng-container *ngIf="obstacleLines?.length > 0">
    <div class="d-flex small-upper-space">
      <div>Obstakels:</div>
      <ul class="inpress-ul smaller-left-space">
        <li *ngFor="let line of obstacleLines">
          <span class="preserve-line-break display-contents">
            <span class="strong inline-flex">{{ line.header }}</span>
            {{ line.line }}
          </span>
        </li>
      </ul>
    </div>
  </ng-container>
  <div
    *ngFor="let product of project.products; let index = index"
    [ngClass]="index > 0 ? 'upper-space' : ''"
  >
    <adjustment-product-summary
      [product]="product"
      [subproject]="subproject"
      [client]="client"
      [index]="index"
      [multipleProducts]="project.products.length > 1"
    ></adjustment-product-summary>
  </div>
</div>
